import { render, staticRenderFns } from "./RoomContent.vue?vue&type=template&id=42bf8d34&scoped=true&"
import script from "./RoomContent.vue?vue&type=script&lang=js&"
export * from "./RoomContent.vue?vue&type=script&lang=js&"
import style0 from "./RoomContent.vue?vue&type=style&index=0&id=42bf8d34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf8d34",
  null
  
)

export default component.exports